import { getAddressSuggestions } from 'shared/api';
import toAddress from './toAddress';

export default async (query) => {
  const response = await getAddressSuggestions(query);
  const { data: { _embedded: { suggestions } } } = response;
  return suggestions.map(toAddress);
};
